import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  REMOVE_ALL_FROM_WISHLIST
} from "../actions/wishlistActions";

const initState = [];

const wishlistReducer = (state = initState, action) => {
  const wishlistItems = state,
  packages = action.payload;

  switch (action.type) {
    case ADD_TO_WISHLIST:
      const wishlistItem = wishlistItems.filter(
        item => item.id === packages.id
      )[0];
      if (wishlistItem === undefined) {
        return [...wishlistItems, packages];
      } else {
        return wishlistItems;
      }

    case REMOVE_FROM_WISHLIST:
      const remainingItems = (wishlistItems, packages) =>
        wishlistItems.filter(wishlistItem => wishlistItem.id !== packages.id);
      return remainingItems(wishlistItems, packages);

    case REMOVE_ALL_FROM_WISHLIST:
      return wishlistItems.filter(item => {
        return false;
      });

    default:
      return wishlistItems;
  }
};

export default wishlistReducer;
